import React from 'react';
import { TitleFieldWrite } from './titleField/TitleFieldWrite';
import { optionsMapperName } from '../../../../../utilities/mapperFunctions';
import { getAttr } from '../../../../../features/helpers/apiHelpers';
import { CONTENTTYPE_TEXT } from '../../../../../constants/api';
import { TitleFieldRead } from './titleField/TitleFieldRead';

const TitleField = ({ fieldData, onChange, isEditMode, validationEntity }) => {
  const fieldTemplates = fieldData.templates || [];
  const [titleContent] = fieldData.textContent || [];

  const templateOptions = fieldTemplates.map(optionsMapperName);
  const titleValue = getAttr(titleContent, 'textContent');

  const onChangeLocal = (value) => onChange(value, CONTENTTYPE_TEXT);

  if (isEditMode) {
    return (
      <TitleFieldWrite
        templateOptions={templateOptions}
        titleValue={titleValue}
        onChange={onChangeLocal}
        validationEntity={validationEntity}
      />
    );
  } else {
    return <TitleFieldRead titleValue={titleValue} />;
  }
};

export { TitleField };
